define((require) => {
    "use strict";

    var Backbone            = require("backbone"),
        ImprovedModel       = require("shared/zbone/ImprovedModel"),
        ProjectModel        = require("ui/editor/project/ProjectModel");

    /**
     * The project meta data.
     *
     * @class ProjectMetadata
     * @constructor
     * @author Poul Henriksen
     */
    return ImprovedModel.extend("Project Metadata", { // Still uses the project distinguished name!

        defaults: {
            project: null
        },

        relations: [
            {
                type: Backbone.One,
                key: "project",
                relatedModel: ProjectModel
            }
        ],

        _distinguishedName: function() {
            var project = this.get("project");

            return project && project._distinguishedName();
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/project/ProjectMetadata.js